import { Subject, Observable } from "rxjs";

import { NoteType } from './note-type.enum';
import { NoteUrgency } from './note-urgency.enum';
import { DetailedFlowHistory, StateType, EntryType, HistoryType } from "../models/flow.dto";
import { WorkOrderWithAssignments } from "../models/work-order.model";
import { File } from './file.model';
import { RetentionPolicy } from './retention-policy.model';

import { INoteable } from './noteable.interface';
import { NoteRelatedItemType } from './note_relatedItemType.enum';

export interface Note extends INoteable {
    id: string;
    documentType: "Note";
    relatedItemId: string;
    relatedItemType: NoteRelatedItemType;
    createdDate?: Date | string;
    createdBy?: string | undefined;
    text?: string | undefined;
    isDeleted?: boolean | undefined;
    noteId?: string;
    retentionPolicy: RetentionPolicy;
    noteUrgency: NoteUrgency;
    files?: File[] | undefined;
    priority?: number | undefined;
    type: NoteType;
    referenceUri: string;
    createdById: string;
    parentNoteId?: string;
}

export interface NotesData {
    currentWorkItem? : string,
    data: any,
    flowOnBehalf?: boolean,
    history: DetailedFlowHistory[],
    reviewNotes: Note[],
    showNotes?: boolean,
    stateType?: StateType,
    workflowId?: string,
    workItems: WorkOrderWithAssignments[]
    obs?: Subject<any>
}

export function objectIsArray(obj): boolean {
    if (!obj)
        return false;

    if (obj instanceof Array)
        return true;

    return false;
}

export interface FlowHistoryItem  {
    id: string,
    userName: string,
    organization: string,
    groupName: string,
    assignedTo: string,
    eventDescription: string,
    eventDate?: string,
    workOrderId: string,
    status: EntryType,
    level: string,
    fullDate: string,
    type: HistoryType
}

export interface NoteFilter {
    fromDate: Date;
    toDate: Date;
    type: string;
    userName: string;
}

export interface UpdateNoteRequest {
    noteId: string;
    itemType: NoteRelatedItemType;
    updatedType?: NoteType;
    deletedState?: boolean;
}